import * as R from 'ramda';
import { fieldNames } from '../formFields/fields';

export const paginateFields = fields => {
    return fields.reduce((data, field) => {
        if (field.component === 'pageBreak') {
            data.pages.push([]);
            data.i++;
        } else {
            data.pages[data.i].push(field);
        }

        return data;
    }, { pages: [[]], i: 0 }).pages;
};

export const updateFieldValue = ({ id, value, activePage }, fields) => {
    function updateField (field) {
        if (field.id !== id) return field;

        const updatedField = R.assoc('value', value, field);
        if (!field.required) return updatedField;

        const valid = checkValidation(updatedField.value);
        return R.assoc('valid', valid, updatedField);
    }
    return R.assocPath(
        [activePage],
        R.map(updateField, fields[activePage]),
        fields
    );
};

export const setValid = (field) => {
  if (field.required) {
    const valid = checkValidation(field.value);
    return { ...field, valid };
  }
  return field;
}

function checkValidation (value) {
    return !R.isEmpty(value) && !R.isNil(value);
}


export const extractSubmissionFields = (fields) => {
    return R.pipe(
        R.flatten(),
        R.reject(rejectUIFields),
        R.reduce(buildSubmissionData, {})
    )(fields);
};

// REMOVE UI-ONLY FIELDS FROM RESPONSE DATA
function rejectUIFields (field) {
    const uiFields = [fieldNames.title, fieldNames.divider, fieldNames.pageBreak, fieldNames.richContent];
    return R.contains(field.component, uiFields);
}

// GENERATE RESPONSE DATA OBJECT FOR EACH REPORTING FIELD
function buildSubmissionData (fields, field) {
    const { reportingLabel, required, label, value: response } = field;
    fields[field.id] = {
      reportingLabel,
      required,
      label,
      response
    };
    return fields;
}
